export default "__VITE_ASSET__Cirj87Ws__"